module.exports = __webpack_public_path__ + "img/logo-2x.17cc5c91.png";